import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { HttpClient } from 'aurelia-fetch-client';

export class AuthInterceptor {

    request(message) {
        if (!StringHelper.IsNullOrEmptyOrUndefined(localStorage[Config.TokenName()]) && localStorage[Config.TokenName()] != null) {
            message.headers.add('Authorization', 'Bearer ' + JSON.parse(localStorage[Config.TokenName()] || null).Token);
        }
        //const clientCookie: string = Cookies.get('ccuid');
        //if (StringHelper.StringIs(clientCookie)) {
        //    message.headers.add('Cookie', 'ccuid=' + clientCookie);
        //    console.log(88888,  message.headers);
        //}
        return message;
    }

    requestError(error) {
        throw error;
    }

    response(message) {
        return message;
    }

    responseError(error) {
        throw error;
    }

}
export class Config {
    private static _instanceName: string = null;
    private static _pathName: string = null;
    private static _apiUrl: string = null;
    private static _instanceUrl: string = null;
    private static _tokenName: string = null;
    private static _imageLogo: string = null;
    private static _headerWrapperImageLogo: string = null;
    private static _progressImageLogo: string = null;
    private static _customViews: Array<Object> = null;
    private static _standardViews: Array<Object> = null;
    private static _standardResources: Array<Object> = null;
    private static _customResources: Array<any> = null;
    private static _vistosVersion: string = null;
    private static timeStamp: number = (new Date()).getTime();
    private static _isMobileApp: boolean = false;
    private static _tabNameFromUrl: string = null;
    private static _goToMessIdFromUrl: number = null;
    private static _goToTrackChangesIdFromUrl: number = null;
    private static _modeFromUrl: string = null;
    private static _toastrs: Object = {};
    private static _isOnline: boolean = true;

    public static SetToastr(id: string, t: JQuery) {
        this._toastrs[id] = t;
    }
    public static GetToastr(id: string): JQuery {
        return this._toastrs[id];
    }

    public static SetModeFromUrl(mode: string) {
        this._modeFromUrl = mode;
    }

    public static FetchModeFromUrl() {
        let mode: string = this._modeFromUrl;
        this._modeFromUrl = null;
        return mode;
    }

    public static SetTabNameFromUrl(tab: string) {
        this._tabNameFromUrl = tab;
    }

    public static FetchTabNameFromUrl() {
        let tab: string = this._tabNameFromUrl;
        this._tabNameFromUrl = null;
        return tab;
    }

    public static SetGoToMessIdFromUrl(id: string) {
        let idInt: number = parseInt(id);
        this._goToMessIdFromUrl = idInt;
    }

    public static FetchGoToMessIdFromUrl() {
        let idInt: number = this._goToMessIdFromUrl;
        this._goToMessIdFromUrl = null;
        return idInt;
    }

    public static SetGoToTrackChangesIdFromUrl(id: string) {
        let idInt: number = parseInt(id);
        this._goToTrackChangesIdFromUrl = idInt;
    }

    public static FetchGoToTrackChangesIdFromUrl() {
        let idInt: number = this._goToTrackChangesIdFromUrl;
        this._goToTrackChangesIdFromUrl = null;
        return idInt;
    }

    public static SetIsOnline(isOnline: boolean) {
        this._isOnline = isOnline;
    }

    public static IsOnline() {
        return this._isOnline;
    }

    public static IsMobileApp() {
        return this._isMobileApp;
    }

    public static InstanceName() {
        return this._instanceName;
    }

    public static TitleSufix() {
        let titleSufix: string = 'Vistos CRM';
        if (this._instanceName == 'Birds') {
            titleSufix = 'FlyBirds.ai';
        }
        return titleSufix;
    }

    public static PathName() {
        return this._pathName;
    }

    public static ApiUrl() {
        return this._apiUrl;
    }

    public static InstanceUrl() {
        return this._instanceUrl;
    }

    public static TokenName() {
        return this._tokenName;
    }

    public static ImageLogo() {
        return this._imageLogo;
    }

    public static HeaderWrapperImageLogo() {
        return this._headerWrapperImageLogo;
    }

    public static ProgressImageLogo() {
        return this._progressImageLogo;
    }

    public static VistosVersion() {
        return this._vistosVersion;
    }

    public static CustomViews() {
        return this._customViews;
    }

    public static StandardViews() {
        return this._standardViews;
    }

    public static StandardResources() {
        return this._standardResources;
    }

    public static CustomResources() {
        return this._customResources;
    }

    public static async Init() {
        const clientCookie: string = Cookies.get('ccuid');
        if (ObjectHelper.IsNullOrUndefinedOrEmptyOrStringEmpty(clientCookie)) {
            Cookies.set('ccuid', GuidHelper.NewGuid(), { expires: 400, secure: true });  // 4000 days 
        }

        if (document.URL.indexOf('birdreview.com') >= 0) {
            this._instanceName = "BirdReview";
            this._pathName = "BirdReview";
            this._apiUrl = "https://www.BirdReview.com/API/VistosAPI";
            this._instanceUrl = "https://birdreview.com/";
            this._tokenName = "aureliaBirdReviewToken";
            this._imageLogo = "Birds-LO-FF_438.png";
            this._customViews = null;
            this._standardViews = null;
            this._standardResources = null;
            this._customResources = null;
            this._headerWrapperImageLogo = 'Birds-LO-FF_438.png';
            this._progressImageLogo = 'Birds-LO-FF_438.png';
        }
        else {
            this._isMobileApp = document.URL.indexOf('http://') === -1 && document.URL.indexOf('https://') === -1;

            if (this._isMobileApp) {
                this._instanceName = "FirmaTestPohoda";
                this._pathName = "FirmaTestPohoda";
                this._apiUrl = "https://eu01.vistoscrm.cz/FirmaTestPohoda/API/VistosAPI";
                this._instanceUrl = "https://eu01.vistoscrm.cz/FirmaTestPohoda/";
                this._tokenName = "aureliaFirmaTestPohodaToken";
                this._imageLogo = "vistos_logo_rgb.png";
                this._customViews = null;
                this._standardViews = null;
                this._standardResources = null;
                this._customResources = null;
                this._headerWrapperImageLogo = 'logo.png';
                this._progressImageLogo = 'vistos_logo_rgb.png';
            }
            else {
                let client = new HttpClient();
                await client.fetch(window.location.pathname + 'config/application.json?nocache=' + this.timeStamp)
                    .then(response => response.json())
                    .then(data => {
                        this._instanceName = data['InstanceName'];
                        this._pathName = data['PathName'];
                        this._apiUrl = data['ApiUrl'];
                        this._instanceUrl = data['ApiUrl'].indexOf('//localhost:') === -1 ? data['ApiUrl'].replace('API/VistosAPI', '') : 'http://localhost:9000/';
                        this._tokenName = data['TokenName'];
                        this._imageLogo = data['ImageLogo'];
                        this._customViews = data['CustomViews'];
                        this._standardViews = data['StandardViews'];
                        this._standardResources = data['StandardResources'];
                        this._customResources = data['CustomResources'];
                        this._headerWrapperImageLogo = data['HeaderWrapperImageLogo'];
                        this._progressImageLogo = data['ProgressImageLogo'];

                        let cssStyle: string = 'Style_Blue.css';
                        if (ObjectHelper.ObjectIs(localStorage[this._tokenName + '_CssStyle']) && StringHelper.StringIs(localStorage[this._tokenName + '_CssStyle'])) {
                            cssStyle = localStorage[this._tokenName + '_CssStyle'];
                        }
                        const defaulStyles: any = document.getElementById('defaul-styles');
                        if (ObjectHelper.ObjectIs(defaulStyles)) {
                            defaulStyles.href = 'scripts/' + cssStyle + '?nocache=' + this.timeStamp;
                        }

                        if (ObjectHelper.IsNotNullAndUndefined(localStorage[this._tokenName])) {
                            let userId: number = JSON.parse(localStorage[this._tokenName])['UserId'];
                            let profileId: number = JSON.parse(localStorage[this._tokenName])['ProfileId'];

                            if (ObjectHelper.IsNotNullAndUndefined(data['HeaderWrapperImageLogoCustom'])) {
                                if (profileId > 0 && ObjectHelper.IsNotNullAndUndefinedAndEmpty(data['HeaderWrapperImageLogoCustom']['ProfileId' + profileId.toString()])) {
                                    this._headerWrapperImageLogo = data['HeaderWrapperImageLogoCustom']['ProfileId' + profileId.toString()];
                                }
                                if (userId > 0 && ObjectHelper.IsNotNullAndUndefinedAndEmpty(data['HeaderWrapperImageLogoCustom']['UserId' + userId.toString()])) {
                                    this._headerWrapperImageLogo = data['HeaderWrapperImageLogoCustom']['UserId' + userId.toString()];
                                }
                            }

                            if (ObjectHelper.IsNotNullAndUndefined(data['ProgressImageLogoCustom'])) {
                                if (profileId > 0 && ObjectHelper.IsNotNullAndUndefinedAndEmpty(data['ProgressImageLogoCustom']['ProfileId' + profileId.toString()])) {
                                    this._progressImageLogo = data['ProgressImageLogoCustom']['ProfileId' + profileId.toString()];
                                }
                                if (userId > 0 && ObjectHelper.IsNotNullAndUndefinedAndEmpty(data['ProgressImageLogoCustom']['UserId' + userId.toString()])) {
                                    this._progressImageLogo = data['ProgressImageLogoCustom']['UserId' + userId.toString()];
                                }
                            }
                        }

                        if (StringHelper.IsNullOrEmptyOrUndefined(this._headerWrapperImageLogo)) {
                            this._headerWrapperImageLogo = 'logo.png';
                        }

                        if (StringHelper.IsNullOrEmptyOrUndefined(this._progressImageLogo)) {
                            this._progressImageLogo = 'vistos_logo_rgb.png';
                        }
                    });

                await client.fetch(window.location.pathname + 'config/vistos.json?nocache=' + this.timeStamp)
                    .then(response => response.json())
                    .then(data => {
                        this._vistosVersion = data['Version'];
                    });
            }
        }
    }
}

export class SchedulerObj {

    public static SchedulerMain: any = null;
    public static SchedulerMain_DataProcessor: any = null;
    public static SchedulerMain_OnBeforeViewChangeEvent: any = null;
    public static SchedulerMain_onBeforeEventChanged: any = null;
    public static SchedulerMain_OnDblClick: any = null;
    public static SchedulerMain_OnLightbox: any = null;
    public static SchedulerMain_EvenCopyModal: any = null;



    public static SchedulerByUnit: any = null;
    public static SchedulerByUnit_DataProcessor: any = null;
    public static SchedulerByUnit_OnBeforeViewChangeEvent: any = null;

    public static SchedulerRental_onBeforeEventChanged: any = null;
    public static SchedulerRental_onBeforeEventDragIn: any = null;
    public static SchedulerRental_onBeforeEventDragOut: any = null;
    public static SchedulerRental_onBeforeDrag: any = null;
    public static SchedulerRental_OnViewMoreClick: any = null;
    public static SchedulerRental_OnDblClick: any = null;
    public static SchedulerRental_OnLightbox: any = null;
    public static SchedulerRental: any = null;
    public static SchedulerRental_DataProcessor: any = null;
    public static SchedulerRental_OnBeforeViewChangeEvent: any = null;
    public static SchedulerRental_OnViewChangeEvent: any = null;
}
